// i18n translations
export const TRANSLATIONS = {
  de: {
    // Nav
    myTasks: "Meine Aufgaben", team: "Team", dashboard: "Dashboard",
    nl2: "NoLimits 2", admin: "Admin", settings: "Einstellungen",
    // Sidebar
    projects: "Projekte",
    // Header
    newTask: "+ Neue Aufgabe", list: "Liste", board: "Board", chat: "Chat",
    milestones: "Milestones", automations: "Auto", tags: "Tags",
    permissions: "Rechte", search: "Suchen�", form: "Formular",
    // Stats
    total: "Gesamt", inProgress: "In Arbeit", done: "Erledigt", urgent: "Dringend",
    // Tasks
    task: "Aufgabe", status: "Status", priority: "Priorit�t", milestone: "Milestone",
    assignees: "Zugewiesen", noTasks: "Keine Aufgaben",
    archiveTask: "Archiviert", archive: "Archiv anzeigen",
    // Detail
    files: "Dateien", checklist: "Checkliste", comments: "Kommentare",
    addItem: "Neuer Punkt�", comment: "Kommentar� (@mention)",
    follow: "Aufgabe folgen", unfollow: "Nicht mehr folgen",
    // Priorities
    pUrgent: "Dringend", pHigh: "Hoch", pMedium: "Mittel", pLow: "Niedrig",
    dringend: "Dringend", hoch: "Hoch", mittel: "Mittel", niedrig: "Niedrig",
    // Admin
    users: "Nutzer", teams: "Teams", backups: "Backups", auditLog: "Audit-Log",
    createUser: "+ Nutzer", createTeam: "+ Team", roles: "?? Rollen", storage: "?? Speicher",
    createBackup: "+ Backup erstellen", resetPassword: "Passwort zur�cksetzen",
    // Reporting
    allProjects: "Alle Projekte", refresh: "? Aktualisieren",
    byStatus: "Nach Status", byProject: "Pro Projekt", projectProgress: "Projektfortschritt",
    activeUsers: "Aktivste Nutzer", recentActivity: "Letzte Aktivit�ten", tagFrequency: "Tag-H�ufigkeit",
    loadData: "Daten laden",
    // My Tasks
    myAssigned: "Mir zugewiesen", myFollowed: "Ich folge", overdue: "�berf�llig", upcoming: "Bald f�llig",
    noAssigned: "Keine zugewiesenen Aufgaben",
    // Buttons
    save: "Speichern", cancel: "Abbrechen", create: "Erstellen", delete: "L�schen",
    edit: "Bearbeiten", close: "Schlie�en", back: "? Zur�ck",
    // Status default
    open: "Offen", inWork: "In Arbeit", review: "Review", finished: "Erledigt",
    // Notifications
    notifications: "Benachrichtigungen", markRead: "Alle gelesen",
    noNotifs: "Keine Benachrichtigungen.",
    // Login
    username: "Benutzername", password: "Passwort", login: "Anmelden ?",
    // Settings
    profile: "Profil", name: "Name", discordId: "Discord ID",
    changePassword: "Passwort �ndern", currentPw: "Aktuelles Passwort",
    newPw: "Neues Passwort", confirmPw: "Best�tigen", avatarColor: "Avatar Farbe",
    discordInfo: "Discord ? Einstellungen ? Erweitert ? Entwicklermodus ? Rechtsklick ? ID kopieren",
    discordEvents: "Du bekommst Discord DMs f�r: Aufgabe zugewiesen, Status�nderung, Kommentare, Erw�hnungen, neue Beta-Releases.",
    testDiscord: "?? Test",
    // Errors
    loading: "Laden�", noAccess: "Kein Zugriff", noProjects: "Noch keine Projekte",
    createFirst: "+ Erstes Projekt erstellen",
    // NL2
    reserved: "Projekt reservieren", release: "? Freigeben & loggen",
    changeLog: "�nderungslog", addEntry: "+ Eintrag", betas: "Beta-Releases",
    betaTeam: "Beta-Team verwalten",
    // Forms
    formTitle: "Formular", formActivate: "Formular aktivieren", publicLink: "�ffentlicher Link",
    copyLink: "Kopieren", formSaved: "Formular gespeichert ?",
  },
  en: {
    myTasks: "My Tasks", team: "Team", dashboard: "Dashboard",
    nl2: "NoLimits 2", admin: "Admin", settings: "Settings",
    projects: "Projects",
    newTask: "+ New Task", list: "List", board: "Board", chat: "Chat",
    milestones: "Milestones", automations: "Auto", tags: "Tags",
    permissions: "Permissions", search: "Search�", form: "Form",
    total: "Total", inProgress: "In Progress", done: "Done", urgent: "Urgent",
    task: "Task", status: "Status", priority: "Priority", milestone: "Milestone",
    assignees: "Assigned", noTasks: "No Tasks",
    archiveTask: "Archived", archive: "Show Archive",
    files: "Files", checklist: "Checklist", comments: "Comments",
    addItem: "New item�", comment: "Comment� (@mention)",
    follow: "Follow task", unfollow: "Unfollow",
    pUrgent: "Urgent", pHigh: "High", pMedium: "Medium", pLow: "Low",
    dringend: "Urgent", hoch: "High", mittel: "Medium", niedrig: "Low",
    users: "Users", teams: "Teams", backups: "Backups", auditLog: "Audit Log",
    createUser: "+ User", createTeam: "+ Team", roles: "?? Roles", storage: "?? Storage",
    createBackup: "+ Create Backup", resetPassword: "Reset Password",
    allProjects: "All Projects", refresh: "? Refresh",
    byStatus: "By Status", byProject: "By Project", projectProgress: "Project Progress",
    activeUsers: "Most Active Users", recentActivity: "Recent Activity", tagFrequency: "Tag Frequency",
    loadData: "Load Data",
    myAssigned: "Assigned to me", myFollowed: "I follow", overdue: "Overdue", upcoming: "Due soon",
    noAssigned: "No assigned tasks",
    save: "Save", cancel: "Cancel", create: "Create", delete: "Delete",
    edit: "Edit", close: "Close", back: "? Back",
    open: "Open", inWork: "In Progress", review: "Review", finished: "Done",
    notifications: "Notifications", markRead: "Mark all read",
    noNotifs: "No notifications.",
    username: "Username", password: "Password", login: "Sign in ?",
    profile: "Profile", name: "Name", discordId: "Discord ID",
    changePassword: "Change Password", currentPw: "Current Password",
    newPw: "New Password", confirmPw: "Confirm", avatarColor: "Avatar Color",
    discordInfo: "Discord ? Settings ? Advanced ? Developer Mode ? Right-click username ? Copy ID",
    discordEvents: "You receive Discord DMs for: task assigned, status change, comments, mentions, new beta releases.",
    testDiscord: "?? Test",
    loading: "Loading�", noAccess: "No Access", noProjects: "No projects yet",
    createFirst: "+ Create first project",
    reserved: "Reserve project", release: "? Release & log",
    changeLog: "Change Log", addEntry: "+ Entry", betas: "Beta Releases",
    betaTeam: "Manage Beta Team",
    formTitle: "Form", formActivate: "Enable Form", publicLink: "Public Link",
    copyLink: "Copy", formSaved: "Form saved ?",
  }
};

export function useT(lang) {
  return TRANSLATIONS[lang] || TRANSLATIONS.de;
}